<template>
  <div>
    <a-row type="flex" justify="end">
      <a-col>
        <a-badge :count="c2cUnreadCount">
          <a-button type="primary" @click="$refs.chat.show()"
            >1v1消息咨询</a-button
          >
        </a-badge>
        <a-button
          style="margin-left:30px"
          type="primary"
          @click="$refs.editGroupModal.show()"
          v-if="isGranted('im_manager.im_group_list.btn_add_group')"
        >
          <a-icon type="plus"></a-icon>新建群组
        </a-button>
      </a-col>
    </a-row>

    <a-row :gutter="80" align="top" style="padding-top:20px;">
      <a-col>
        <a-table
          :pagination="false"
          :dataSource="groupList"
          :columns="columns"
          rowKey="id"
          :loading="{ spinning: loading, tip: '加载中' }"
          :customRow="customRow"
        >
          <template slot="name" slot-scope="name, record">
            <a-badge :count="record.unreadCount" dot>
              <span>{{ name }}</span>
            </a-badge>
          </template>
          <template slot="action" slot-scope="record">
            <a-row
              type="flex"
              :gutter="10"
              justify="start"
              v-if="record.is_disbanded == 0"
            >
              <a-col>
                <a
                  @click.prevent.stop="editGroup(record)"
                  v-if="isGranted('system_setting.role_manager.btn_list_edit')"
                  >编辑</a
                >
              </a-col>
              <a-col>
                <a
                  @click.prevent.stop="$refs.joinPostModal.show(record)"
                  v-if="
                    isGranted(
                      'system_setting.role_manager.btn_list_permission_set'
                    ) && record.type === 'IE_POST'
                  "
                  >关联职位</a
                >
              </a-col>
              <a-col>
                <a
                  @click.prevent.stop="dismiss(record)"
                  v-if="
                    isGranted('system_setting.role_manager.btn_list_delete')
                  "
                  >解散</a
                >
              </a-col>
            </a-row>
            <span v-else>已解散</span>
          </template>
        </a-table>
      </a-col>
    </a-row>
    <edit-group-modal
      ref="editGroupModal"
      @ok="updateGroupList"
    ></edit-group-modal>
    <join-post-modal ref="joinPostModal"></join-post-modal>
    <conversation ref="conversation"></conversation>
    <chat-conversation ref="chat"></chat-conversation>
  </div>
</template>

<script>
import Api from "@/api";
import moment from "moment";
import { createNamespacedHelpers } from "vuex";
const {
  mapMutations,
  mapState,
  mapActions,
  mapGetters
} = createNamespacedHelpers("im");
import baseComponentVue from "@/components/base-component.vue";
import EditGroupModal from "./edit-group-modal";
import JoinPostModal from "./join-post-modal";
import Conversation from "./conversation/index";
import ChatConversation from "./c2c/index";
import imgBind from "@/shared/utils/imgBind";
export default {
  name: "im",
  extends: baseComponentVue,
  data() {
    return {
      loading: false,
      columns: [],
      conversationList: []
    };
  },
  components: { EditGroupModal, JoinPostModal, Conversation, ChatConversation },
  computed: {
    ...mapState(["groupList"]),
    ...mapGetters(["c2cUnreadCount"])
  },
  async created() {
    this.setColumns();
  },
  methods: {
    ...mapActions(["updateGroupList"]),
    setColumns() {
      let columns = [
        {
          title: "群名",
          dataIndex: "name",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "群类型",
          dataIndex: "type",
          customRender: text => (text === "IE_POST" ? "IE做单群" : "非IE做单群")
        },
        {
          title: "消息数",
          dataIndex: "message_count",
          align: "center"
        },
        {
          title: "成员数",
          dataIndex: "member_count",
          align: "center"
        },
        {
          title: "最近活跃时间",
          dataIndex: "last_update_date"
          // customRender: text =>
          //   moment(text * 1000).format("YYYY-MM-DD HH:mm:ss")
        },
        {
          title: "创建人",
          dataIndex: "nick_name",
          // customRender: text => {
          //   return this.$store.state.user.name;
          // }
        },
        {
          title: "创建时间",
          dataIndex: "creation_date"
          // customRender: text =>
          //   moment(text * 1000).format("YYYY-MM-DD HH:mm:ss")
        }
      ];
      if (
        this.isAnyGranted([
          "system_setting.role_manager.btn_list_edit",
          "system_setting.role_manager.btn_list_permission_set",
          "system_setting.role_manager.btn_list_delete"
        ])
      ) {
        columns.push({
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" }
        });
      }
      this.columns = columns;
    },
    editGroup(record) {
      if(!record.is_master) {
        this.$message.warning('您不是该群组的创建人，无权编辑群组');
      } else {
        this.$refs.editGroupModal.show(record)
      }
    },
    dismiss(record) {
      if(!record.is_master) {
        this.$message.warning('您不是该群组的创建人，无权解散群组');
        return false;
      }
      const h = this.$createElement;
      this.$confirm({
        title: "群管理-解散",
        content: h("div", { style: { paddingTop: "20px" } }, [
          h("p", `确定解散群“${record.name}”？`),
          h("p", "解散后不可恢复！")
        ]),
        onOk: () => {
          return new Promise(async (resolve, reject) => {
            try {
              await Api.im.dismissGroup({ group_id: record.id });
              this.updateGroupList();
              resolve();
            } catch (e) {
              this.$message.error(e);
              reject();
            }
          });
        }
      });
    },
    customRow(record) {
      return {
        on: {
          click: () => {
            if (record.is_disbanded == 0) {
              if(record.is_master) {
                this.$refs.conversation.show("GROUP" + record.id);
              } else {
                this.$message.warning('您不是该群组的创建人，无法打开群聊');
              }
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .ant-table-row {
  cursor: pointer;
}
</style>
